import { render, staticRenderFns } from "./NeoparentLayout.vue?vue&type=template&id=58cdbd5a"
import script from "./NeoparentLayout.vue?vue&type=script&lang=js"
export * from "./NeoparentLayout.vue?vue&type=script&lang=js"
import style0 from "./NeoparentLayout.vue?vue&type=style&index=0&id=58cdbd5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports